import { modules } from "byzantine";
import DirectDepositLandingPage from "./DirectDepositLandingPage";
import { InstitutionSettingsContextProvider } from "../contexts/InstitutionSettingsContext";

const { Provider: DirectDepositFormProvider } =
  modules.directDeposit.directDepositEnrollmentForm;

const DirectDepositPage = () => (
  <InstitutionSettingsContextProvider>
    <DirectDepositFormProvider>
      <DirectDepositLandingPage />
    </DirectDepositFormProvider>
  </InstitutionSettingsContextProvider>
);

export default DirectDepositPage;
